import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Warning = createSvgIcon(
  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z M13.05 14.1V6.4h-2.1v7.7h2.1ZM12 17.6a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1Z" />,
  'Warning'
);

export { Warning };